import React, { useEffect } from 'react'
import { connect } from 'react-redux'
import PropTypes from 'prop-types'
import { licenseeApplicationClearState } from 'reducers/licenseeApplication/reducer'
import LicenseeApplicationList from './LicenseeApplicationList'
import LicenseeApplicationItem from './LicenseeApplicationItem'

function LicenseeApplication(props) {
  const {
    match: {
      params: { id },
    },
    licenseeApplicationClearState,
  } = props
  const LicenseeApplicationContent = id
    ? LicenseeApplicationItem
    : LicenseeApplicationList

  useEffect(
    () => () => {
      licenseeApplicationClearState()
    },
    [],
  )

  return (
    <div className="content">
      <LicenseeApplicationContent {...props} />
    </div>
  )
}

LicenseeApplication.propTypes = {
  match: PropTypes.shape({
    params: PropTypes.shape({
      id: PropTypes.string,
    }),
  }).isRequired,
  licenseeApplicationClearState: PropTypes.func.isRequired,
}

export default connect(null, {
  licenseeApplicationClearState,
})(LicenseeApplication)
